import React, { ReactElement, useContext, useState } from "react"

import { Button, Loading, Modal } from "@wfp/ui"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons"
import { MappingPriceContext } from "../../../../providers/MappingPricesContext"

import SingleRow from "./SingleRow"
import MappingStepHeader from "./MappingStepHeader"

const MappingFields = (): ReactElement => {
  const [discardedModal, setDiscardedModal] = useState<boolean>(false)

  const { discardedCols, mappingRows, loadingMapping, resetErrorModal, errorModal, onRestoreRow } =
    useContext(MappingPriceContext)

  if (loadingMapping)
    return (
      <div className="min-h-[430px] w-full flex justify-center items-center">
        <Loading small withOverlay={false} />
      </div>
    )

  return (
    <div>
      <div className="flex justify-between">
        <MappingStepHeader
          title="Fields Mapping"
          descriptions={[
            "Let's map the fields in the Excel file you have uploaded.",
            "Map the fields to the corresponding columns in the Excel file.",
          ]}
        />

        {!!discardedCols.length && (
          <div className="w-4/12 flex justify-end">
            <Button className="w-48 relative test-sm" small onClick={() => setDiscardedModal(true)}>
              Restore Column(s)
              <div
                className="absolute bottom-4 left-44 bg-red-600 rounded-full flex justify-center items-center"
                style={{ minHeight: "1.2rem", minWidth: "1.2rem", fontSize: "0.65rem" }}
              >
                {discardedCols.length}
              </div>
            </Button>
          </div>
        )}
      </div>

      <div className="mt-3">
        {mappingRows
          ?.filter(item => !discardedCols.includes(item.colName))
          ?.map(row => (
            <SingleRow key={row.colIndex} row={row} />
          ))}
      </div>

      <Modal
        lazyLoad
        modalHeading="Invalid values"
        onRequestClose={resetErrorModal}
        open={errorModal.show}
        passiveModal
        type="danger"
      >
        <div className="max-h-96 text-sm overflow-y-auto px-2">
          {errorModal.invalidValues.map(value => (
            <div key={value.row} className="mb-1 border border-gray-200 border-dashed p-2 rounded-md">
              <p className="font-bold text-[var(--support-01)]">{value.value}</p>
              <p className="text-gray-600">
                The value in the cell at row <b>{value.row}</b> is invalid.
              </p>
            </div>
          ))}
        </div>
      </Modal>

      <Modal
        lazyLoad
        modalHeading="Restore Discarded Column(s)"
        onRequestClose={() => setDiscardedModal(false)}
        open={discardedModal}
        passiveModal
      >
        <div className="max-h-96 overflow-auto text-sm">
          {discardedCols.map(col => (
            <div key={col} className="flex justify-between border-b border-gray-200 border-dashed py-1 items-center">
              <div className="flex mr-3">
                <p className="mr-2">
                  <b>{col}</b>
                </p>
                <p>{mappingRows.find(sv => sv.colName === col)?.cellValue}</p>
              </div>
              <FontAwesomeIcon
                icon={faRotateLeft}
                color="var(--interactive-01)"
                size="lg"
                className="cursor-pointer"
                onClick={() => onRestoreRow(col)}
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default MappingFields
